module.exports = __webpack_public_path__ + "static/Nudista-Italic-3185f854ca5d33bb9986511508e6eceb.ttf";